import React from "react"
import { connect } from "react-redux"
import { values, omit, difference, sortBy, keys, keyBy, range } from "lodash"
import Flip from "react-flip-move"
import { Panel, ButtonGroup } from "react-bootstrap"
import { createSelector } from 'reselect'
import PropTypes from "prop-types"
import FileSaver from "file-saver"

import Button from "../components/Button"
import { randstr } from "../../lib/Tools"
import * as Actions from '../ducks/trips'
import { createExcelBlob } from '../../lib/xlsx.js'

import "./TripPeople.less"
import { countKids, countAdults } from "../../lib/TripTools"

/**
 * 
 */

function downloadExcel(name, people, order) {
  const data = people.data || {}
  const couples = people.couples || {}

  const headers = [["Gender", "Name", "Passport", "Age", "Partner", "Notes"]]

  const rows = order.map(k => data[k])
    .map(({ gender, key, name, passport, age, note }) => ([
      {M: "Male", F: "Female", "?": "Unknown", O: "Other"}[gender || "?"],
      name,
      passport,
      age,
      (couples[key] ? data[couples[key]].name : ""),
      note
    ]))

  const style = {
    cols: [80, 120, 100, 50, 120, 160].map(wpx => ({wpx})),
    cells: {
      "A1-X1": {
        font: { bold: true, sz: "18" }, 
      },
      "A2-L50000": {
        font: { sz: "14" },
        alignment: { horizontal: "left" }
      }
    }
  }

  FileSaver.saveAs(
    createExcelBlob([...headers, ...rows], style),
    `Viajeros ${name}.xlsx`
  )
}

/**
 * 
 */

const props = {
  name: PropTypes.string.isRequired,
  people: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  order: PropTypes.arrayOf(PropTypes.string).isRequired
}

class TripPeople extends React.PureComponent 
{
  addPeople(n, age) {
    const nonce = randstr(2) // not really a nonce right?
    const newPeople = range(n).map((i) => ({
      key: `zz${(new Date()).getTime()}${nonce}${i}`,
      passport: "",
      name: "",
      age: null || age,
    }))

    this.props.onChange({
      data: {
        ...this.props.people.data,
        ...keyBy(newPeople, "key")
      }
    })
  }

  addPeopleClick(kids = false) {
    const s = prompt(kids ? "¿Cuántos niños?" : "¿Cuántos adultos?")
    const n = parseInt(s)
    if (s && n) {
      this.addPeople(n, kids ? 12 : null)
    }
  }

  editPerson(key, change) {
    this.props.onChange({
      data: {
        ...this.props.people.data,
        [key]: {
          ...this.props.people.data[key],
          ...change
        }
      }
    })
  }

  marry(k1, k2) {
    const couples = this.props.people.couples || {}
    this.props.onChange({ couples: {
      ...omit(couples, [k1, k2, couples[k1], couples[k2]]),
      [k1]: k2, 
      [k2]: k1
    }})
  } 

  divorce(k) {
    const couples = this.props.people.couples || {}
    this.props.onChange({ couples: omit(couples, [k, couples[k]]) })
  }

  kill(key) {
    const leader = this.props.people.leader
    const partner = this.props.people.couples[key]

    this.props.onChange({
      couples: omit(this.props.people.couples, [key, partner]),
      data: omit(this.props.people.data, key),
      leader: (leader == key ? "null" : leader),
    })
  }

  changeLeader(key) {
    this.props.onChange({ 
      leader: this.props.people.leader == key ? null : key 
    })
  }

  render() {
    const people = this.props.people
    const data = people.data || {}
    const couples = people.couples || {}

    const singles = difference(
      keys(data), 
      keys(couples)
    )

    const nadults = countAdults({people})
    const nkids = countKids({people})
    const ntotal = values(data).length 

    return (
      <Panel>
        <Panel.Heading className="trip-people-heading">
          <Panel.Title>
            <b>Datos de los viajeros</b>
            <i style={{marginLeft: 30}}>
              ({nadults} adultos, {nkids} niños, {ntotal} en total)
            </i>
          </Panel.Title>

          <div className="buttons">
            <ButtonGroup>

              <Button
                glyph="plus"
                onClick={this.addPeopleClick.bind(this, false)}
              >
                Añadir adultos
              </Button>

              <Button
                glyph="plus"
                onClick={this.addPeopleClick.bind(this, true)}
              >
                Añadir niños
              </Button>
            </ButtonGroup>

            <Button 
              className="dlb"
              glyph="download" 
              onClick={() => downloadExcel(this.props.name, this.props.people, this.props.order)}
            >
              Descargar en Excel
            </Button>

          </div>
        </Panel.Heading>
        <Panel.Body>
          <div className="trip-people">
            <Flip
              staggerDurationBy="10"
              duration={100}
              enterAnimation="accordionVertical"
              leaveAnimation="accordionVertical"
              typeName="div"
            >
              {
                this.props.order.map(k => data[k])
                  .map(({ gender, key, name, passport, age, note }) => (
                    <Panel 
                      key={key} 
                      className={(
                        "person "
                        + (
                          couples[key] 
                            ? (couples[key] > key ? "first " : "second ")
                            : ""
                        )
                        + (
                          (age === null || age > 16) ? "adult" : "kid"
                        )
                      )}
                    >
                      <Panel.Body>
                        <Button 
                          style={{ marginRight: 5 }}
                          onClick={() => this.changeLeader(key)} 
                          bsSize="xsmall"
                          active={people.leader == key}
                        >
                          {
                            people.leader == key 
                              ? <span style={{fontSize: "1.2em", color: "orange"}}>✭</span> 
                              : <span style={{fontSize: "1.2em"                 }}>✩</span>
                          }
                        </Button>

                        <select 
                          name="g" value={gender} 
                          onChange={evt => this.editPerson(key, { gender: evt.target.value })}
                        >
                          <option value="?">Género?</option>
                          <option value="M">♂ Hombre</option>
                          <option value="F">♀ Mujer</option>
                          <option value="O">﹖Otro</option>
                        </select>
                        <label>Edad:</label>
                        <input 
                          placeholder={30}
                          value={age} 
                          onChange={evt => {
                            const age = Math.max(parseInt(evt.target.value), 0)
                            this.editPerson(key, { age })
                          }}
                          type="number" 
                        />
                        <label>Nombre:</label>
                        <input 
                          value={name} 
                          placeholder="Sin nombre"
                          onChange={evt => this.editPerson(key, { name: evt.target.value })} 
                        />
                        <label>Pasaporte:</label>
                        <input 
                          value={passport} 
                          onChange={evt => this.editPerson(key, { passport: evt.target.value })} 
                        />
                        <label>Pareja: </label>
                        <select 
                          name="p"
                          value={couples[key] || "SINGLE"}
                          onChange={evt => {
                            if (evt.target.value == "SINGLE") this.divorce(key)
                            else this.marry(key, evt.target.value)
                          }}
                        >
                          <option value="SINGLE">Soltero</option>
                          {
                            couples[key] && (
                              <option value={couples[key]}>{data[couples[key]].name}</option>
                            )
                          }
                          {
                            singles.map(sk => (
                              sk != key && <option value={sk}>{data[sk].name}</option>
                            ))
                          }
                        </select>
                        <label>Nota:</label>
                        <input 
                          className="note"
                          value={note || ""} 
                          onChange={evt => this.editPerson(key, { note: evt.target.value })} 
                        />

                        <Button
                          glyph="remove"
                          disabled={ntotal == 1}
                          onClick={() => this.kill(key)}
                        />
                      </Panel.Body>
                    </Panel>
                  ))
              }
            </Flip>

          </div>
        </Panel.Body>
      </Panel>
    )
  }
}

TripPeople.propTypes = props

/**
 * 
 */

const getOrder = people => (
  sortBy(keys(people.data), k => {
    const partner = (people.couples || {})[k]
    if (partner < k) return partner + "Z"
    else return k
  })
)

const getOrderSelector = createSelector(
  [(stateIgnored, ownProps) => ownProps.people],
  people => getOrder(people)
)

const mapStateToProps = (state, ownProps) => ({
  order: getOrderSelector(state, ownProps),
})

export default connect(mapStateToProps)(TripPeople)
